import React from 'react';

import {
  Link,
  useHistory
} from "react-router-dom";

import { Root, Content, Section, Footer, FooterRow, FooterColumn, Logos, StyledChannelLogo, StyledHeader } from './styles';

import { Toolbar } from '@ard-online/component-styleguide/dist/components/Toolbar/Toolbar';
import { ThemeProvider } from 'styled-components';
import { Row, Column } from '@ard-online/component-styleguide/dist/components/primitives/Grid';
import ardCiTheme from './ardCiTheme';

import ScrollToTop from './ScrollToTop';

export default function PrivacyPolicy() {

  const [value, setValue] = React.useState('de');

  const toolbarRef = React.createRef();

  const history = useHistory();
  const handleClick = () => history.push('/');

  const channelLinks = {
    br: "https://www.br.de/br-fernsehen/",
    hr: "https://www.hr-fernsehen.de/",
    mdr: "https://www.mdr.de/tv",
    ndr: "https://www.ndr.de/fernsehen/",
    radiobremen: "https://dein.radiobremen.de/",
    rbb: "https://www.rbb-online.de/fernsehen",
    sr: "https://www.sr.de/sr/home/fernsehen/index.html",
    swr: "https://www.swrfernsehen.de/",
    wdr: "https://www1.wdr.de/fernsehen",
    dw: "https://www.dw.com/",
    daserste: "https://www.daserste.de/",
    one: "https://www.ardmediathek.de/one/",
    tagesschau24: "https://www.tagesschau24.de/",
    alpha: "https://www.ardmediathek.de/alpha/",
    '3sat': "https://www.3sat.de",
    arte: "https://www.arte.de",
    kika: "https://www.kika.de/",
    phoenix: "https://www.phoenix.de/",
    funk: "https://www.funk.net/",
    deutschlandradio: "https://www.deutschlandradio.de/",
    zdf: "https://www.zdf.de/",
  }

  const toolbarData = {
    actionIconsRight: [
      { icon: "account", text: value },
    ],
    items: [
      { text: "zurück zur Hauptseite", href: '#', onClick: handleClick },
    ],
    logoButton: {
      as: Link,
      type: 'text',
      text: "zurück zur Hauptseite",
      onClick: handleClick
    },
    accountNavigationItems: [
      { text: "deutsch" },
      { text: "english", href: '/en', onClick: (e) => { setValue(e.target.innerText.substring(0, 2)) } }
    ],
  }

  return (
    <ThemeProvider theme={ardCiTheme}>
      <StyledHeader ref={toolbarRef} className="header">
        <Toolbar {...toolbarData} hasLogo hasCenteredLogo={false} fixed={true} />
      </StyledHeader>
      <main>
        <Root>
          <Row>
            <Column>
              <Content>
                <Section>
                  <section>
                    <Row>
                      <Column>
                        <h2>Datenschutzerklärung</h2>
                        
                        <p>Im Folgenden möchten wir Sie in verständlicher und kompakter Form über die Erhebung und Verarbeitung Ihrer Daten sowie Ihre diesbezüglichen Rechte unterrichten.</p>
                        
                        <h3>I. Verantwortliche Stelle</h3>
                        
                        <p>WDR mediagroup GmbH<br/>
                          Ludwigstrasse 11<br/>
                          50667 Köln<br/>
                          E-Mail: info@wdr-mediagroup.com</p>
                        
                        <h3>II. Datenschutzbeauftragte</h3>
                        
                        <p>WDR mediagroup GmbH<br/>
                          - Datenschutz -<br/>
                          Ludwigstrasse 11<br/>
                          50667 Köln<br/>
                          E-Mail: datenschutz@wdr-mediagroup.com</p>

                        <h3>III.	Allgemeines zur Datenverarbeitung</h3>

                        <p><strong>1. Umfang und Zwecke der Verarbeitung personenbezogener Daten</strong></p>

                        <p>Wir verarbeiten personenbezogene Daten</p>

                        <p>a) zur Erfüllung vertraglicher Pflichten (Art. 6 Abs. 1 lit. b DSGVO)</p>

                        <p>Die Verarbeitung von Daten erfolgt zur Erfüllung von Verträgen oder zur Durchführung vorvertraglicher Maßnahmen, die auf Ihre Anfrage hin erfolgen.</p> 

                        <p>b) aufgrund eines berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO)</p>

                        <p>Soweit erforderlich, werden Ihre Daten über die vorstehenden Zwecke hinaus zur Wahrung berechtigter Interessen verarbeitet. </p>

                        <ul>
                          <li>Verbesserung und Weiterentwicklung des Angebots,</li>
                          <li>Maßnahmen zur Geschäftssteuerung und Weiterentwicklung,</li>
                          <li>Gewährleistung der IT-Sicherheit und des IT-Betriebs der Website, </li>
                          <li>Geltendmachung von Ansprüchen und Verteidigung bei rechtlichen Streitigkeiten,</li>
                          <li>Maßnahmen zur Gebäude- und Anlagensicherheit (z.B. Zutrittskontrollen), </li>
                          <li>Maßnahmen zur Sicherstellung des Hausrechts, </li>
                          <li>Werbung oder Markt- und Meinungsforschung soweit Sie der Nutzung Ihrer Daten nicht widersprochen haben,</li>
                        </ul>

                        <p>c) aufgrund Ihrer Einwilligung (Art. 6 Abs. 1 a DSGVO)</p>

                        <p>Soweit Sie uns eine Einwilligung zur Verarbeitung von personenbezogenen Daten für bestimmte Zwecke (z.B. Newsletter-Versand) erteilt haben, ist diese Einwilligung die Rechtsgrundlage für die Verarbeitung. Eine erteilte Einwilligung kann jederzeit mit Wirkung für die Zukunft widerrufen werden. </p>

                        <p>Zudem verarbeiten wir – soweit für die Erbringung unserer Dienstleistung erforderlich – personenbezogene Daten, die wir aus öffentlich zugänglichen Quellen (z.B. Presse, Internet) zulässigerweise gewinnen oder die uns von anderen Unternehmen der WDR mediagroup GmbH oder von sonstigen Dritten berechtigt übermittelt werden.</p>

                        <p><strong>2. Datenlöschung und Speicherdauer</strong></p>

                        <p>Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn dies etwa gesetzlich vorgeschrieben ist, oder soweit die weitere Speicherung der Daten für einen Vertragsabschluss oder eine Vertragserfüllung erforderlich ist.</p>

                        <p><strong>3.	Weitergabe von Informationen (personenbezogener Daten) an Dritte</strong></p>

                        <p>Zur Verarbeitung Ihrer Daten setzen wir ggf. zum Teil spezialisierte Dienstleister ein. Diese erhalten von uns nur die personenbezogenen Daten, die sie für ihre konkrete Tätigkeit benötigen. Die Dienstleister werden von uns sorgfältig ausgewählt und regelmäßig kontrolliert. Sie verarbeiten personenbezogene Daten nur im Auftrag und strikt nach unseren Weisungen auf der Grundlage entsprechender Verträge über die Auftragsverarbeitung.</p>

                        <p>Soweit die von uns eingesetzten Dienstleister, die in unserem Auftrag und im Rahmen unserer Weisungen als sog. Auftragsverarbeiter gemäß Art. 28 DSGVO personenbezogene Daten für uns verarbeiten, außerhalb der EU/dem EWR ansässig sind, stellen wir vor der Übermittlung von Daten an diese sicher, dass bei diesen ein angemessenes Datenschutzniveau besteht (z.B. Angemessenheitsbeschluss der EU-Kommission/ Abschluss EU-Standardvertragsklauseln etc.).</p>

                        <h3>IV.	Verarbeitung personenbezogener Daten</h3>

                        <p><strong>1. Automatisch erfasste Informationen beim Besuch unserer Website</strong></p>

                        <p>Sie können unsere Webseite besuchen, ohne Angaben zu Ihrer Person zu machen. Bei jedem Aufruf einer Webseite speichert der Webserver lediglich automatisch ein sogenanntes Server-Logfile, das u.a. den Namen der angeforderten Datei, Ihre IP-Adresse, Datum und Uhrzeit des Abrufs, übertragene Datenmenge und den anfragenden Provider (Zugriffsdaten) enthält und den Abruf dokumentiert. Diese Zugriffsdaten sind:</p>
                        
                        <ul>
                          <li>Ihre IP-Adresse</li>
                          <li>Name der abgerufenen Website/Datei</li>
                          <li>Datum und Uhrzeit des Zugriffs</li>
                          <li>Übertragene Datenmenge</li>
                          <li>Meldung über erfolgreichen Abruf</li>
                          <li>Browser-Typ und Version</li>
                          <li>Verwendetes Betriebssystem </li>
                          <li>Verwendetes Endgerät, inkl. MAC-Adresse</li>
                          <li>Referrer-URL (die zuvor besuchte Seite)</li>
                        </ul>

                        <p>Diese Zugriffsdaten werden ausschließlich zum Zwecke der Sicherstellung eines störungsfreien Betriebs der Seite sowie zur Verbesserung unseres Angebots und der Möglichkeit, Angriffe zu erkennen und zu verfolgen, ausgewertet. Dies dient der Wahrung unserer im Rahmen einer Interessenabwägung überwiegenden berechtigten Interessen an einer korrekten Darstellung unseres Angebots im Sinne des Art. 6 Abs. 1 lit. f DSGVO.</p>

                        <p><strong>2. Daten, die Sie uns zur Verfügung stellen</strong></p>

                        <p>Sie können über die bereitgestellten Kontaktmöglichkeiten (Formular, E-Mail, Telefon) jederzeit mit uns Kontakt aufnehmen. Dabei werden die von Ihnen eingegeben Daten an uns übermittelt und gespeichert und zur Bearbeitung Ihres Anliegens verwendet.</p>

                        <p>Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. </p>

                        <h3>V. Ihre Rechte</h3>

                        <p>Sie haben u.a. das Recht, Auskunft über die (zu Ihrer Person) von uns gespeicherten Daten zu verlangen. Darüber hinaus können Sie unter bestimmten Voraussetzungen die Berichtigung oder die Löschung Ihrer Daten verlangen. Weiterhin steht Ihnen ein Recht auf Einschränkung der Verarbeitung Ihrer Daten sowie ein Recht auf Herausgabe der von Ihnen bereitgestellten Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu.</p>

                        <p>Beruht eine Datenverarbeitung auf einer von Ihnen erteilten Einwilligung, können Sie diese Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen. Erfolgt eine Datenverarbeitung aufgrund überwiegender berechtigter Interessen können Sie dieser Datenverarbeitung widersprechen, wenn dies Ihre besondere Situation rechtfertigt.</p>
                        
                        <p>Jeder Betroffene hat außerdem das Recht, sich bei einer Aufsichtsbehörde zu beschweren, wenn er der Ansicht ist, dass ein Verstoß gegen datenschutzrechtliche Regelungen vorliegt.</p>

                        <p>Die für uns zuständige Aufsichtsbehörde ist</p>

                        <p>Der Rundfunkdatenschutzbeauftragte<br/>
                        Stephan Schwarze<br/>
                        Kantstr. 71-73<br/>
                        04275 Leipzig</p>

                        <h3>VI.	Aktualität und Änderung dieser Datenschutzerklärung</h3>

                        <p>Diese Datenschutzerklärung ist aktuell gültig und hat den Stand 06.2023.</p>

                        <p>Durch die Weiterentwicklung unserer Website und Angebote darüber oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Datenschutzerklärung kann jederzeit hier abgerufen werden. </p>

                      </Column>
                    </Row>
                  </section>
                </Section>
              </Content>
            </Column>
          </Row>
        </Root>
      </main>
        <footer>
          <Footer>
            <FooterRow>
              <FooterColumn>
                <Row>
                  <Column>
                    <nav><ul >
                      <li><Link to="/impressum">Impressum</Link></li>
                      <li className="active"><strong>Datenschutz</strong></li>
                    </ul></nav>
                  </Column>
                </Row>
                <Row>
                  <Column p="0">
                    <Logos>
                      {Object.keys(channelLinks).map((channelKey, index) => 
                        <a key={index} href={channelLinks[channelKey]}><StyledChannelLogo key={channelKey} channel={channelKey} /></a>
                      )}
                    </Logos>
                  </Column>
                </Row>
              </FooterColumn>
            </FooterRow>
          </Footer>
        </footer>
        <ScrollToTop />
    </ThemeProvider>
  );

}